<div class="menu-internas-pagina" *ngIf="menuPage?.length > 0">
  <ul>
    <li
      id="item-menu-{{ menu.id }}"
      *ngFor="let menu of menuPage; let index = index"
      [class.desabilitado]="menu?.desabilitar"
      [class.marcado]="menu?.active"
      (click)="actionMenu(menu)"
    >
      <span>{{ menu?.descricao }}</span>
      <fa-icon [icon]="getIcon(menu?.class)" class="icon-trash"></fa-icon>
    </li>
  </ul>
</div>
